module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('div', {
    staticClass: "ushk-price ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-price__wrap"
  }, [_c('div', {
    staticClass: "ushk-price__b"
  }, [_c('div', {
    staticClass: "ushk-price__marquee marquee3k",
    attrs: {
      "id": "J_price_marquee",
      "data-pausable": "true",
      "data-speed": "0.8"
    }
  }, _vm._l((_vm.wrapNum), function(n) {
    return _c('div', {
      staticClass: "ushk-price__group J_price_group"
    }, _vm._l((_vm.datas), function(value, key) {
      return _c('div', {
        key: key,
        staticClass: "ushk-price__item J_price_item",
        attrs: {
          "data-code": key
        }
      }, [_c('div', {
        staticClass: "ushk-price__content"
      }, [_c('h5', {
        staticClass: "ushk-price__name"
      }, [_vm._v("\n                  " + _vm._s(value.name) + "\n                  "), _c('span', [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('div', {
        staticClass: "ushk-price__value"
      }, [_c('span', {
        style: ({
          color: value.bTextColor,
          'background-color': value.bgColor
        })
      }, [_vm._v(_vm._s(value.bValue || '--'))])]), _vm._v(" "), _c('div', {
        staticClass: "ushk-price__value"
      }, [_c('span', {
        style: ({
          color: value.textColor
        })
      }, [_vm._v(_vm._s(value.pValue || '--'))]), _vm._v(" "), _c('i', {
        staticClass: "ushk-icon",
        class: 'ushk-icon_' + value.dir,
        style: ({
          color: value.textColor
        })
      })])])])
    }), 0)
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acb135e4","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/Price/index.vue
// module id = GoUn
// module chunks = 1